export default __webpack_public_path__ + "static/media/apple-icon.b5d876e2.png";